// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemSettings_wrapper__f9vZa","wrap":"ItemSettings_wrap__cYaV2"};